import React, { useState, useCallback, useRef, useEffect } from 'react';
import speech from '../../core/SpeechService';

const PIXABAY_API_KEY = '33745979-6e793453ab99977fccede77c0';

// ── Sprüche-Bibliothek — große Auswahl pro Kategorie ──
const SPRUECHE = {
  birthday: {
    lustig: [
      'Ab jetzt sind die Kerzen auf deiner Torte teurer als die Torte selbst.',
      'Du wirst nicht älter — nur wertvoller. Leider wie ein Gebrauchtwagen.',
      'Alter ist nur eine Zahl. In deinem Fall leider eine ziemlich hohe.',
      'Du bist nicht älter geworden — nur... retro.',
      'Alt genug, um es besser zu wissen. Jung genug, um es trotzdem zu tun.',
      'Früher warst du jung und wild. Heute bist du froh, wenn du beides überlebst.',
      'Geburtstage sind wie Zecken: Sie kommen jedes Jahr wieder und lassen sich nicht vermeiden.',
      'Ab einem gewissen Alter heißt wild feiern: zwei Bier, Sofa und um 22 Uhr schlafen.',
      'Die Falten sind nicht schlimm — das ist die Verpackung deiner Lebenserfahrung.',
      'Du bist wie guter Käse: Mit der Zeit reif, aromatisch und etwas eigensinnig.',
      'Man ist nur so alt, wie man sich fühlt. Also heute mindestens 90 nach dem Aufstehen.',
      'Feiere schön — in deinem Alter weiß man nie, wie viele noch kommen.',
      'Du bist jetzt offiziell im Club der Früher-war-alles-besser-Menschen.',
      'Heute ist dein Tag! Ab morgen wieder Alltag, Rückenschmerzen und Wetterfühligkeit.',
      'Geburtstage sind wie Steuerbescheide: Niemand will sie, aber sie kommen trotzdem.',
      'Du wirst nicht alt, du sammelst nur Level wie in einem Videospiel — nur ohne Neustart.',
      'Die Haare werden grauer, die Witze schärfer — Gratulation!',
      'Noch ein Jahr näher an Was wollte ich gerade sagen...?',
      'Du bist nicht 50. Du bist 18 mit 32 Jahren Erfahrung.',
      'Du bist nicht alt, du bist ein Klassiker.',
      'Herzlichen Glückwunsch! Jetzt bist du offiziell zu alt für TikTok-Tänze.',
      'Geburtstag? Wieder ein Grund für Kalorien, die man feiern darf.',
      'Wenn man morgens mehr knackt als das Müsli, ist man wohl offiziell erwachsen.',
      'Deine Jugend ist jetzt volljährig. Lass sie ziehen.',
      'Auf deinem Geburtstagskuchen brennt mehr Feuer als auf dem Grill.',
      'Geburtstage halten dich jung — zumindest innerlich. Äußerlich hilft nur noch Licht aus.',
      'Kuchen ist Liebe. Kalorien sind Gefühle. Heute darfst du fühlen.',
      'Glückwunsch! Du siehst kein bisschen aus wie dein Geburtsjahrgang.',
      'An deinem Geburtstag zählen nicht die Jahre, sondern die Tortenstücke.',
      'Jung geblieben ist nur ein Codewort für reif mit jugendlichem Trotz.',
      'Lass dich feiern wie ein Rockstar — nur mit mehr Kaffee als Bier.',
      'Du bist jetzt im Alter, in dem du vergisst, wie alt du bist.',
      'Kuchen löst keine Probleme. Aber das tut ein Geburtstag auch nicht. Also: Kuchen!',
      'Geburtstag ist wie ein Software-Update: Man weiß nie, was nachher noch funktioniert.',
      'Willkommen im VIP-Club der grauen Haare und guten Ausreden.',
      'Noch ein Jahr näher an der perfekten Ausrede für Mittagsschläfchen.',
    ],
    herzlich: [
      'Das Leben hat dir so viel gegeben — und du gibst noch mehr zurück.',
      'Möge jeder Tag so besonders sein wie du es für uns bist.',
      'Ein neues Lebensjahr voller Glück, Gesundheit und unvergesslicher Momente.',
      'Du machst die Welt ein Stückchen schöner — einfach indem du da bist.',
      'Auf viele weitere Jahre voller Lachen, Liebe und guter Zeiten!',
      'Heute feiern wir den Menschen, der unser Leben so viel reicher macht.',
      'Alles Gute! Bleib so wunderbar, wie du bist.',
      'Dein Lächeln erhellt jeden Raum — Happy Birthday!',
    ],
  },
  abi: {
    motivierend: [
      'Hut ab! Die Welt gehört dir.',
      '12 Jahre Anlauf, jetzt wird abgehoben!',
      'Erst das Abi, dann die Welt!',
      'Der Jahrgang der Legenden!',
      'Du hast es geschafft — jetzt beginnt das Abenteuer!',
      'Mit Vollgas durchs Abi — und jetzt ab in die Freiheit!',
      'Box dich durchs Abi — du hast es geschafft!',
      'Vorhang auf für die nächste Etappe deines Lebens!',
      'Das Wars — möge die Zukunft mit dir sein!',
      'Hol das letzte raus — du hast bewiesen, dass du es kannst!',
      'Ende Abi, Anfang Uni — die Reise geht weiter!',
      'Auf zum Gipfel — das Abi war nur der Anfang!',
      'Gemeinsam geschafft, gemeinsam gefeiert!',
      'Nur noch ein paar Schritte — und du hast es allen gezeigt!',
      'Wir sind stolz auf dich — du rockst das!',
      'Von der Schulbank in die große weite Welt!',
      'ABI — Ab Ins Leben!',
      'Heute Abitur, morgen die Welt!',
    ],
    lustig: [
      'Abi geschafft — jetzt kann das echte Lernen beginnen!',
      '13 Jahre Gruppenzwang — offiziell beendet!',
      'Endlich frei! Und jetzt? Erstmal Netflix.',
      'Abi 2026 — wie konnten die uns durchlassen?',
      'Wir kamen, sahen und bestanden — irgendwie.',
      'Abi-Streich war gut, Abi-Note eher so mittel.',
      'Fertig! Und das sogar ohne Google-Übersetzer im Deutsch-Abi.',
    ],
  },
  wedding: {
    romantisch: [
      'Zwei Herzen, ein Weg — für immer und ewig.',
      'Die schönste Reise beginnt heute — Hand in Hand.',
      'Liebe ist nicht das was man erwartet zu bekommen, sondern das was man bereit ist zu geben.',
      'In deinen Augen habe ich mein Zuhause gefunden.',
      'Heute beginnt unser gemeinsames Für-Immer.',
      'Die Liebe kennt keine Grenzen — nur gemeinsame Wege.',
      'Zusammen ist unser liebster Ort.',
      'Ein Ja, das alles verändert — und doch alles richtig macht.',
      'Liebe ist, wenn aus zwei Geschichten ein gemeinsames Buch wird.',
      'Von heute an gehen wir jeden Schritt gemeinsam.',
      'Wo du bist, ist mein Herz zu Hause.',
      'Nicht perfekt, aber perfekt füreinander.',
    ],
    klassisch: [
      'Was Gott zusammenfügt, soll der Mensch nicht trennen.',
      'Möge eure Liebe mit jedem Tag stärker werden.',
      'Für immer und drei Tage — mindestens!',
      'Ein Band der Liebe, das kein Sturm zerreißen kann.',
    ],
  },
  jubilee: {
    feierlich: [
      'Jahre voller Leidenschaft, Einsatz und Erfolg — Herzlichen Glückwunsch!',
      'Was vor so vielen Jahren begann, ist heute stärker denn je!',
      'Ein Meilenstein, auf den man stolz sein kann!',
      'Tradition trifft Zukunft — seit vielen Jahren erfolgreich.',
      'Danke für Jahre voller Vertrauen und Zusammenarbeit.',
      'Auf die nächsten Jahre — mit der gleichen Begeisterung!',
      'Was lange währt, wird endlich gut — und bei euch war es schon immer gut!',
      'Ein Grund zum Feiern: Jahre voller Erinnerungen!',
      'Erfolg ist kein Zufall — er ist das Ergebnis von Hingabe.',
      'Die beste Zeit liegt nicht hinter uns — sie kommt noch!',
    ],
  },
  welcome: {
    herzlich: [
      'Schön, dass du da bist! Fühl dich wie zu Hause.',
      'Ein herzliches Willkommen — wir freuen uns auf euch!',
      'Endlich da! Wir haben schon auf euch gewartet.',
      'Willkommen in der Familie!',
      'Herein, herein — hier bist du richtig!',
      'Die Tür steht offen, das Herz sowieso.',
      'Willkommen! Macht es euch gemütlich.',
      'Zuhause ist, wo man willkommen ist.',
    ],
  },
  party: {
    feier: [
      'Lasst uns feiern, als gäbe es kein Morgen!',
      'Die besten Erinnerungen entstehen auf den besten Partys!',
      'Heute wird getanzt, gelacht und gefeiert!',
      'Party-Modus: aktiviert!',
      'Das Leben ist zu kurz für langweilige Partys!',
      'Einmal um die Welt tanzen — und dann nochmal!',
      'Konfetti im Herzen, Musik in der Seele!',
      'Wer nicht feiert, hat verloren!',
      'Heute Nacht gehört uns!',
      'Die beste Party ist die, die nie endet!',
      'Alle zusammen — lasst es krachen!',
    ],
  },
  baby: {
    süß: [
      'Klein, süß und wunderbar — willkommen in unserer Welt!',
      'Ein kleines Wunder hat das Licht der Welt erblickt!',
      'Zehn kleine Finger, zehn kleine Zehen — ein großes Glück!',
      'Endlich bist du da — wir haben so auf dich gewartet!',
      'Ein Stern ist geboren — und er leuchtet so hell!',
      'So klein und schon so geliebt!',
      'Willkommen, kleines Wunder!',
      'Das größte Abenteuer beginnt im Kleinsten.',
      'Mit dir wird jeder Tag ein bisschen magischer.',
      'Ein neues Kapitel beginnt — das schönste von allen.',
    ],
  },
  farewell: {
    wertschätzend: [
      'Jeder Abschied ist der Anfang einer neuen Reise.',
      'Du gehst, aber die Erinnerungen bleiben — Danke für alles!',
      'Wir lassen dich ungern gehen — aber wir wissen, Großes wartet auf dich!',
      'Danke für die gemeinsame Zeit — sie war unbezahlbar.',
      'Mach die Welt da draußen ein bisschen besser — so wie du es hier getan hast.',
      'Nicht Tschüss, sondern Bis bald!',
      'Du hinterlässt Spuren, die nicht so leicht verblassen.',
      'Auf Wiedersehen heißt: Wir sehen uns wieder!',
      'Die besten Kollegen sind die, die man vermisst.',
      'Neue Wege, neue Chancen — du packst das!',
    ],
  },
  business: {
    professionell: [
      'Qualität, die überzeugt — seit Jahren.',
      'Ihr Partner für erstklassige Lösungen.',
      'Innovation trifft Tradition.',
      'Gemeinsam stark — für Ihren Erfolg.',
      'Vertrauen Sie auf Erfahrung und Kompetenz.',
      'Die Zukunft beginnt hier.',
      'Besuchen Sie uns — wir freuen uns auf Sie!',
      'Exzellenz ist kein Ziel, sondern unser Standard.',
    ],
  },
};

// Font-Zuordnung nach Stimmung/Kategorie
const SPRUCH_FONTS = {
  birthday: { lustig: 'Caveat', herzlich: 'Dancing Script' },
  abi: { motivierend: 'Permanent Marker', lustig: 'Caveat' },
  wedding: { romantisch: 'Great Vibes', klassisch: 'Playfair Display' },
  jubilee: { feierlich: 'Cormorant Garamond' },
  welcome: { herzlich: 'Quicksand' },
  party: { feier: 'Fredoka One' },
  baby: { süß: 'Pacifico' },
  farewell: { wertschätzend: 'Lora' },
  business: { professionell: 'Montserrat' },
};

// Headline-Fonts pro Kategorie
const HEADLINE_FONTS = {
  birthday: 'Pacifico',
  abi: 'Oswald',
  wedding: 'Great Vibes',
  jubilee: 'Oswald',
  welcome: 'Raleway',
  party: 'Fredoka One',
  baby: 'Pacifico',
  farewell: 'Raleway',
  business: 'Oswald',
};

// Subline-Fonts pro Kategorie
const SUBLINE_FONTS = {
  birthday: 'Raleway',
  abi: 'Raleway',
  wedding: 'Raleway',
  jubilee: 'Raleway',
  welcome: 'Inter',
  party: 'Raleway',
  baby: 'Quicksand',
  farewell: 'Inter',
  business: 'Raleway',
};

// Mood-Labels für die UI
const MOOD_LABELS = {
  lustig: 'Lustig & Frech',
  herzlich: 'Herzlich & Liebevoll',
  motivierend: 'Motivierend',
  romantisch: 'Romantisch',
  klassisch: 'Klassisch',
  feierlich: 'Feierlich',
  süß: 'Süß & Liebevoll',
  wertschätzend: 'Wertschätzend',
  professionell: 'Professionell',
  feier: 'Party-Stimmung',
};

function getRandomSpruch(categoryId, preferredMood) {
  const catSprueche = SPRUECHE[categoryId];
  if (!catSprueche) return { text: '', font: 'Dancing Script', mood: '' };
  const moods = Object.keys(catSprueche);
  // Use preferred mood if available, otherwise random
  const mood = (preferredMood && catSprueche[preferredMood]) ? preferredMood : moods[Math.floor(Math.random() * moods.length)];
  const list = catSprueche[mood];
  const text = list[Math.floor(Math.random() * list.length)];
  const font = SPRUCH_FONTS[categoryId]?.[mood] || 'Dancing Script';
  return { text, font, mood };
}

function getMoodsForCategory(categoryId) {
  const catSprueche = SPRUECHE[categoryId];
  if (!catSprueche) return [];
  return Object.keys(catSprueche);
}

function getSpruchCount(categoryId) {
  const catSprueche = SPRUECHE[categoryId];
  if (!catSprueche) return 0;
  return Object.values(catSprueche).reduce((sum, list) => sum + list.length, 0);
}

// ── Anlass-Kategorien ──
const OCCASION_CATEGORIES = [
  {
    id: 'birthday',
    label: 'Geburtstag',
    icon: '🎂',
    pixabayQuery: 'birthday celebration cake candles',
    fallbackBg: '#1e3a5f',
    questions: [
      { key: 'name', label: 'Wie heißt das Geburtstagskind?', placeholder: 'z.B. Max' },
      { key: 'age', label: 'Wie alt wird es?', placeholder: 'z.B. 30', type: 'number' },
      { key: 'dedication', label: 'Widmung (optional)', placeholder: 'z.B. Es gratulieren Deine Nachbarn, Alles Gute wünschen dir Mama & Papa' },
    ],
  },
  {
    id: 'abi',
    label: 'Abi-Banner',
    icon: '🎓',
    pixabayQuery: 'graduation celebration confetti',
    fallbackBg: '#0f172a',
    questions: [
      { key: 'name', label: 'Name des Abiturienten', placeholder: 'z.B. Lisa' },
      { key: 'year', label: 'Abi-Jahrgang', placeholder: 'z.B. 2026', type: 'number' },
      { key: 'motto', label: 'Abi-Motto (optional)', placeholder: 'z.B. ABI Vegas — Alles auf eine Karte' },
      { key: 'dedication', label: 'Widmung (optional)', placeholder: 'z.B. Wir sind stolz auf dich! Mama & Papa' },
    ],
  },
  {
    id: 'wedding',
    label: 'Hochzeit',
    icon: '💍',
    pixabayQuery: 'wedding romantic flowers elegant',
    fallbackBg: '#1a1a2e',
    questions: [
      { key: 'name1', label: 'Name der Braut', placeholder: 'z.B. Anna' },
      { key: 'name2', label: 'Name des Bräutigams', placeholder: 'z.B. Thomas' },
      { key: 'date', label: 'Datum der Hochzeit (optional)', placeholder: 'z.B. 15. Juni 2026' },
      { key: 'dedication', label: 'Widmung (optional)', placeholder: 'z.B. Alles Liebe wünschen euch eure Freunde' },
    ],
  },
  {
    id: 'jubilee',
    label: 'Jubiläum',
    icon: '🏆',
    pixabayQuery: 'celebration gold anniversary',
    fallbackBg: '#1e1b4b',
    questions: [
      { key: 'name', label: 'Wer feiert?', placeholder: 'z.B. Firma Müller' },
      { key: 'years', label: 'Wie viele Jahre?', placeholder: 'z.B. 25', type: 'number' },
      { key: 'type', label: 'Art des Jubiläums', placeholder: 'z.B. Firmenjubiläum, Ehejubiläum' },
      { key: 'dedication', label: 'Widmung (optional)', placeholder: 'z.B. Herzlichen Glückwunsch von allen Mitarbeitern' },
    ],
  },
  {
    id: 'welcome',
    label: 'Willkommen',
    icon: '👋',
    pixabayQuery: 'welcome banner colorful',
    fallbackBg: '#064e3b',
    questions: [
      { key: 'name', label: 'Wen begrüßt du?', placeholder: 'z.B. Familie Schmidt, Team Berlin' },
      { key: 'event', label: 'Anlass (optional)', placeholder: 'z.B. Einschulung, Umzug, Besuch' },
    ],
  },
  {
    id: 'party',
    label: 'Party & Feier',
    icon: '🎉',
    pixabayQuery: 'party celebration colorful lights',
    fallbackBg: '#7c2d12',
    questions: [
      { key: 'title', label: 'Titel der Feier', placeholder: 'z.B. Sommerparty, Grillabend' },
      { key: 'date', label: 'Datum (optional)', placeholder: 'z.B. 20. Juli 2026' },
      { key: 'location', label: 'Ort (optional)', placeholder: 'z.B. Im Garten, Clubhaus' },
    ],
  },
  {
    id: 'baby',
    label: 'Baby & Taufe',
    icon: '👶',
    pixabayQuery: 'baby pastel cute soft',
    fallbackBg: '#1e3a5f',
    questions: [
      { key: 'name', label: 'Name des Babys', placeholder: 'z.B. Emma' },
      { key: 'type', label: 'Anlass', placeholder: 'z.B. Geburt, Taufe, Babyparty' },
      { key: 'date', label: 'Datum (optional)', placeholder: 'z.B. 12. März 2026' },
      { key: 'dedication', label: 'Widmung (optional)', placeholder: 'z.B. Es freuen sich Oma & Opa' },
    ],
  },
  {
    id: 'farewell',
    label: 'Abschied',
    icon: '🫶',
    pixabayQuery: 'farewell sunset beautiful landscape',
    fallbackBg: '#292524',
    questions: [
      { key: 'name', label: 'Für wen ist der Abschied?', placeholder: 'z.B. Herr Müller, Kollegin Lisa' },
      { key: 'reason', label: 'Anlass', placeholder: 'z.B. Ruhestand, Jobwechsel, Umzug' },
      { key: 'dedication', label: 'Widmung (optional)', placeholder: 'z.B. Dein Team aus der Buchhaltung' },
    ],
  },
  {
    id: 'business',
    label: 'Geschäftlich',
    icon: '🏢',
    pixabayQuery: 'business modern architecture professional',
    fallbackBg: '#0f172a',
    questions: [
      { key: 'company', label: 'Firmenname', placeholder: 'z.B. Muster GmbH' },
      { key: 'slogan', label: 'Slogan oder Botschaft', placeholder: 'z.B. Qualität seit 1990' },
      { key: 'event', label: 'Anlass (optional)', placeholder: 'z.B. Messe, Eröffnung, Aktion' },
    ],
  },
];

// ── Kategorie-Labels für Template-Gallery ──
const TEMPLATE_CATEGORY_LABELS = {
  alle: 'Alle',
  birthday: 'Geburtstag',
  abi: 'Abi-Banner',
  wedding: 'Hochzeit',
  jubilee: 'Jubiläum',
  welcome: 'Willkommen',
  party: 'Party & Feier',
  baby: 'Baby & Taufe',
  farewell: 'Abschied',
  business: 'Geschäftlich',
};

// ── Design-Generierung: Headlines/Sublines pro Kategorie ──
function generateDesignTexts(categoryId, answers) {
  switch (categoryId) {
    case 'birthday':
      return {
        headline: `Happy Birthday\n${answers.name || ''}!`,
        subline: answers.age ? `${answers.age} Jahre` : 'Alles Gute!',
      };
    case 'abi':
      return {
        headline: answers.motto || `ABI ${answers.year || '2026'}`,
        subline: answers.name ? `Herzlichen Glückwunsch, ${answers.name}!` : 'Wir haben es geschafft!',
      };
    case 'wedding':
      return {
        headline: `${answers.name1 || ''}\n&\n${answers.name2 || ''}`,
        subline: answers.date ? `Wir heiraten! — ${answers.date}` : 'Wir heiraten!',
      };
    case 'jubilee':
      return {
        headline: `${answers.years || ''} Jahre\n${answers.name || ''}`,
        subline: answers.type ? `${answers.type} — Wir feiern!` : 'Wir feiern!',
      };
    case 'welcome':
      return {
        headline: `Herzlich\nWillkommen!`,
        subline: answers.name || '',
      };
    case 'party':
      return {
        headline: answers.title || "Let's Party!",
        subline: [answers.date, answers.location].filter(Boolean).join(' — ') || 'Ihr seid alle eingeladen!',
      };
    case 'baby':
      return {
        headline: `Willkommen\n${answers.name || ''}!`,
        subline: answers.type ? `${answers.type}${answers.date ? ' — ' + answers.date : ''}` : 'Ein kleines Wunder!',
      };
    case 'farewell':
      return {
        headline: `Alles Gute,\n${answers.name || ''}!`,
        subline: answers.reason ? `Wir wünschen dir alles Gute zum ${answers.reason}!` : 'Du wirst uns fehlen!',
      };
    case 'business':
      return {
        headline: answers.company || 'Ihr Unternehmen',
        subline: answers.slogan || 'Wir freuen uns auf Sie!',
      };
    default:
      return { headline: '', subline: '' };
  }
}

// ── Pixabay-Suche ──
async function searchPixabay(query, perPage = 9) {
  try {
    const q = encodeURIComponent(query);
    const url = `https://pixabay.com/api/?key=${PIXABAY_API_KEY}&q=${q}&image_type=photo&per_page=${perPage}&page=1&lang=de&orientation=horizontal&min_width=1200`;
    const res = await fetch(url);
    const data = await res.json();
    return data.hits || [];
  } catch (err) {
    console.error('Pixabay-Fehler:', err);
    return [];
  }
}

// ── Placeholder-Mapping: editableField keys → Template-Platzhalter ──
const PLACEHOLDER_MAP = {
  name: '{{NAME}}',
  age: '{{ALTER}}',
  year: '{{JAHRGANG}}',
  motto: '{{MOTTO}}',
  dedication: '{{WIDMUNG}}',
  name1: '{{NAME1}}',
  name2: '{{NAME2}}',
  date: '{{DATUM}}',
  years: '{{JAHRE}}',
  type: '{{TYP}}',
  event: '{{EVENT}}',
  title: '{{TITEL}}',
  location: '{{ORT}}',
  reason: '{{GRUND}}',
  company: '{{FIRMA}}',
  slogan: '{{SLOGAN}}',
};

// ── Template-Platzhalter im Canvas-JSON ersetzen ──
function replaceTemplatePlaceholders(canvasJson, fieldValues) {
  let jsonStr = JSON.stringify(canvasJson);
  for (const [key, value] of Object.entries(fieldValues)) {
    const placeholder = PLACEHOLDER_MAP[key] || `{{${key.toUpperCase()}}}`;
    // Replace all occurrences of the placeholder
    jsonStr = jsonStr.split(placeholder).join(value || '');
  }
  return JSON.parse(jsonStr);
}

// ── Skeleton-Karte (Ladeanimation) ──
function SkeletonCard() {
  return (
    <div className="rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-[#3a3a3c] animate-pulse">
      <div className="aspect-video bg-gray-200 dark:bg-gray-600" />
      <div className="p-3 space-y-2">
        <div className="h-3.5 bg-gray-200 dark:bg-gray-600 rounded w-3/4" />
        <div className="h-2.5 bg-gray-200 dark:bg-gray-600 rounded w-1/2" />
      </div>
    </div>
  );
}

// ── Hauptkomponente ──
function TemplateWizard({ canvasManager, onClose }) {
  // Mode: 'gallery' = Template-Katalog, 'wizard' = bisheriger Wizard-Flow
  const [mode, setMode] = useState('gallery');

  // ── Wizard-States (bestehend) ──
  const [step, setStep] = useState('categories');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [answers, setAnswers] = useState({});
  const [bgImages, setBgImages] = useState([]);
  const [bgLoading, setBgLoading] = useState(false);
  const [selectedBg, setSelectedBg] = useState(null);
  const [generating, setGenerating] = useState(false);
  const [currentSpruch, setCurrentSpruch] = useState({ text: '', font: 'Dancing Script', mood: '' });
  const [selectedMood, setSelectedMood] = useState(null); // null = random
  const firstInputRef = useRef(null);

  // ── Gallery-States (neu) ──
  const [galleryTemplates, setGalleryTemplates] = useState([]);
  const [galleryLoading, setGalleryLoading] = useState(true);
  const [galleryError, setGalleryError] = useState(null);
  const [galleryCategory, setGalleryCategory] = useState('alle');
  const [galleryCategories, setGalleryCategories] = useState(['alle']);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templateFieldValues, setTemplateFieldValues] = useState({});
  const [templateLoading, setTemplateLoading] = useState(false);
  const [galleryStep, setGalleryStep] = useState('browse'); // 'browse' | 'customize'

  // ── Templates vom Backend-API laden ──
  useEffect(() => {
    if (mode !== 'gallery') return;
    let cancelled = false;

    async function fetchTemplates() {
      setGalleryLoading(true);
      setGalleryError(null);
      try {
        const apiBase = process.env.REACT_APP_API_URL || '/designer/api';
        const res = await fetch(`${apiBase}/templates`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (cancelled) return;

        // Map API response to gallery format
        const templates = (Array.isArray(data) ? data : []).map(t => {
          // Build editable fields from placeholder markers found in canvas_json
          const PLACEHOLDER_FIELD_MAP = {
            NAME: { key: 'name', label: 'Name', placeholder: 'z.B. Max' },
            ALTER: { key: 'age', label: 'Alter', placeholder: 'z.B. 30' },
            JAHRGANG: { key: 'year', label: 'Jahrgang', placeholder: 'z.B. 2026' },
            MOTTO: { key: 'motto', label: 'Motto', placeholder: 'z.B. ABI Vegas' },
            WIDMUNG: { key: 'dedication', label: 'Widmung', placeholder: 'z.B. Alles Gute wünschen dir...' },
            NAME1: { key: 'name1', label: 'Name 1', placeholder: 'z.B. Anna' },
            NAME2: { key: 'name2', label: 'Name 2', placeholder: 'z.B. Thomas' },
            DATUM: { key: 'date', label: 'Datum', placeholder: 'z.B. 15. Juni 2026' },
            JAHRE: { key: 'years', label: 'Anzahl Jahre', placeholder: 'z.B. 25' },
            TYP: { key: 'type', label: 'Art/Typ', placeholder: 'z.B. Firmenjubiläum' },
            EVENT: { key: 'event', label: 'Anlass', placeholder: 'z.B. Messe, Eröffnung' },
            TITEL: { key: 'title', label: 'Titel', placeholder: 'z.B. Sommerparty' },
            ORT: { key: 'location', label: 'Ort', placeholder: 'z.B. Im Garten' },
            GRUND: { key: 'reason', label: 'Grund', placeholder: 'z.B. Ruhestand' },
            FIRMA: { key: 'company', label: 'Firmenname', placeholder: 'z.B. Muster GmbH' },
            SLOGAN: { key: 'slogan', label: 'Slogan', placeholder: 'z.B. Qualität seit 1990' },
          };
          const editableFields = (t.placeholders || [])
            .map(p => PLACEHOLDER_FIELD_MAP[p])
            .filter(Boolean);

          return {
            id: t.id,
            name: t.name,
            category: t.template_category || '',
            thumbnail: `${apiBase}/designs/${t.id}/preview`,
            width_cm: t.width_cm,
            height_cm: t.height_cm,
            editableFields,
            description: t.width_cm && t.height_cm ? `${t.width_cm} × ${t.height_cm} cm` : '',
          };
        });

        setGalleryTemplates(templates);

        // Kategorien aus Templates extrahieren
        const cats = ['alle', ...Array.from(new Set(templates.map(t => t.category).filter(Boolean)))];
        setGalleryCategories(cats);
      } catch (err) {
        console.error('Templates konnten nicht geladen werden:', err);
        if (!cancelled) setGalleryError('Vorschläge konnten nicht geladen werden.');
      } finally {
        if (!cancelled) setGalleryLoading(false);
      }
    }

    fetchTemplates();
    return () => { cancelled = true; };
  }, [mode]);

  // ── Gefilterte Templates ──
  const filteredTemplates = galleryCategory === 'alle'
    ? galleryTemplates
    : galleryTemplates.filter(t => t.category === galleryCategory);

  // ── Template auswählen → Customize-View ──
  const handleSelectTemplate = useCallback((template) => {
    setSelectedTemplate(template);
    // Felder beibehalten wenn gleicher Key existiert, sonst leer/default
    setTemplateFieldValues(prev => {
      const merged = {};
      (template.editableFields || []).forEach(f => {
        merged[f.key] = prev[f.key] || f.default || '';
      });
      return merged;
    });
    setGalleryStep('customize');
  }, []);

  // ── Template-Feld ändern ──
  const handleTemplateFieldChange = useCallback((key, value) => {
    setTemplateFieldValues(prev => ({ ...prev, [key]: value }));
  }, []);

  // ── Template laden und auf Canvas anwenden ──
  const handleLoadTemplate = useCallback(async () => {
    if (!selectedTemplate || !canvasManager) return;
    setTemplateLoading(true);

    try {
      const apiBase = process.env.REACT_APP_API_URL || '/designer/api';
      // Fetch full design data from backend API
      const res = await fetch(`${apiBase}/designs/${selectedTemplate.id}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const designData = await res.json();

      // Extract canvas_json from API response
      let canvasJson = designData.canvas_json;
      if (!canvasJson) {
        throw new Error('Vorlage enthält keine Canvas-Daten');
      }

      // Platzhalter ersetzen
      const processedJson = replaceTemplatePlaceholders(canvasJson, templateFieldValues);

      // Canvas laden via canvasManager.loadJSON (handles font preloading, etc.)
      speech.mute();
      await canvasManager.loadJSON(processedJson);

      // Ensure all non-decoration objects are selectable
      canvasManager.canvas.getObjects().forEach(obj => {
        if (obj.selectable === false && obj.evented === false) return; // keep locked deco
        obj.set({ selectable: true, evented: true, hasControls: true, hasBorders: true });
      });

      // Redraw overlays (bleed, hem, grommets)
      canvasManager.drawBleedLines(canvasManager.bleedCm);
      canvasManager.drawHemLines(canvasManager.hemPerSide || canvasManager.hemCm);
      canvasManager.drawHohlsaum(canvasManager.hohlsaumConfig);
      canvasManager.drawGrommets(canvasManager.grommetsConfig, canvasManager.hemPerSide || canvasManager.hemCm);
      canvasManager.canvas.renderAll();
      speech.unmute();
      // Nicht vorlesen

      setTemplateLoading(false);
      onClose();
    } catch (err) {
      console.error('Fehler beim Laden der Vorlage:', err);
      speech.unmute();
      setTemplateLoading(false);
      alert('Vorlage konnte nicht geladen werden. Bitte versuche es erneut.');
    }
  }, [selectedTemplate, templateFieldValues, canvasManager, onClose]);

  // ── Prüfen ob mindestens ein Pflichtfeld ausgefüllt ──
  const canLoadTemplate = selectedTemplate && selectedTemplate.editableFields && selectedTemplate.editableFields.length > 0
    ? selectedTemplate.editableFields.some(f => templateFieldValues[f.key]?.trim())
    : true;

  // ── Wizard: bestehende Logik ──
  useEffect(() => {
    if (step === 'questions' && firstInputRef.current) {
      setTimeout(() => firstInputRef.current.focus(), 200);
    }
  }, [step]);

  // Generate spruch when entering background step or mood changes
  useEffect(() => {
    if (step === 'background' && selectedCategory) {
      setCurrentSpruch(getRandomSpruch(selectedCategory.id, selectedMood));
    }
  }, [step, selectedCategory, selectedMood]);

  const handleSelectCategory = useCallback((cat) => {
    setSelectedCategory(cat);
    setAnswers({});
    setSelectedBg(null);
    setBgImages([]);
    setCurrentSpruch({ text: '', font: 'Dancing Script', mood: '' });
    setSelectedMood(null);
    setStep('questions');
  }, []);

  const handleAnswerChange = useCallback((key, value) => {
    setAnswers(prev => ({ ...prev, [key]: value }));
  }, []);

  const handleRefreshSpruch = useCallback(() => {
    if (!selectedCategory) return;
    setCurrentSpruch(getRandomSpruch(selectedCategory.id, selectedMood));
  }, [selectedCategory, selectedMood]);

  const handleNextToBackground = useCallback(async () => {
    if (!selectedCategory) return;
    setBgLoading(true);
    setStep('background');
    setSelectedBg(null);

    const hits = await searchPixabay(selectedCategory.pixabayQuery, 12);
    setBgImages(hits);
    setBgLoading(false);

    if (hits.length > 0) {
      setSelectedBg({ type: 'image', url: hits[0].largeImageURL, preview: hits[0].webformatURL });
    }
  }, [selectedCategory]);

  // ── Design auf Canvas generieren ──
  const handleGenerate = useCallback(() => {
    if (!canvasManager || !selectedCategory) return;
    setGenerating(true);

    setTimeout(() => {
      speech.mute();
      const fabric = window.fabric;
      if (!fabric) { setGenerating(false); speech.unmute(); return; }

      const texts = generateDesignTexts(selectedCategory.id, answers);
      const scale = canvasManager.getObjScale();
      const vW = canvasManager.vWidth;
      const vH = canvasManager.vHeight;
      const hasImage = selectedBg && selectedBg.type === 'image';
      const canvas = canvasManager.canvas;
      const maxW = Math.round(vW * 0.80);

      // Helper: Shadow
      const mkShadow = (blur, oy) => new fabric.Shadow({
        color: 'rgba(0,0,0,0.9)', blur: Math.round(blur * scale), offsetX: 0, offsetY: Math.round(oy * scale),
      });

      // Helper: Add a Textbox — centered, with shadow, stroke, proper wrapping
      const addTextbox = (text, opts) => {
        const tb = new fabric.Textbox(text, {
          width: opts.width || maxW,
          left: Math.round(vW / 2),
          originX: 'center',
          originY: 'top',
          textAlign: 'center',
          fill: '#ffffff',
          paintFirst: 'stroke',
          strokeLineJoin: 'round',
          strokeLineCap: 'round',
          editable: false,
          ...opts,
        });
        canvas.add(tb);
        return tb;
      };

      // 1. Set background
      if (hasImage) {
        canvasManager.setBackgroundImage(selectedBg.url);
      } else {
        canvasManager.setBackgroundColor(selectedCategory.fallbackBg);
      }

      // 2. Dark overlay for image backgrounds
      if (hasImage) {
        const overlay = new fabric.Rect({
          left: 0, top: 0, width: vW, height: vH,
          fill: 'rgba(0,0,0,0.45)',
          selectable: true, evented: true,
          customName: 'Hintergrund-Overlay',
        });
        canvas.add(overlay);
        canvas.sendToBack(overlay);
      }

      // ════════════════════════════════════════════
      //  GRAFISCHES LAYOUT — Professionelles Plakatdesign
      // ════════════════════════════════════════════

      // ── HEADLINE: Groß, dominant, oberes Drittel ──
      addTextbox(texts.headline, {
        top: Math.round(vH * 0.08),
        fontSize: Math.round(80 * scale),
        fontFamily: HEADLINE_FONTS[selectedCategory.id] || 'Pacifico',
        fontWeight: 'bold',
        shadow: mkShadow(25, 6),
        stroke: '#000000',
        strokeWidth: Math.max(1, Math.round(2.5 * scale)),
        customName: 'Überschrift',
        lineHeight: 1.1,
      });

      // ── SUBLINE: Mittlerer Bereich, Versalien mit Spacing für Eleganz ──
      if (texts.subline) {
        const isShort = texts.subline.length < 20;
        addTextbox(texts.subline.toUpperCase(), {
          top: Math.round(vH * 0.50),
          fontSize: Math.round((isShort ? 28 : 24) * scale),
          fontFamily: SUBLINE_FONTS[selectedCategory.id] || 'Raleway',
          fontWeight: '600',
          charSpacing: Math.round(300),
          shadow: mkShadow(14, 3),
          stroke: '#000000',
          strokeWidth: Math.max(1, Math.round(1.5 * scale)),
          customName: 'Untertitel',
          lineHeight: 1.3,
          fill: 'rgba(255,255,255,0.95)',
        });
      }

      // ── SPRUCH: Unteres Drittel, kursiv, eigene Schriftart ──
      if (currentSpruch.text) {
        addTextbox(`„${currentSpruch.text}"`, {
          top: Math.round(vH * 0.68),
          fontSize: Math.round(22 * scale),
          fontFamily: currentSpruch.font,
          fontStyle: 'italic',
          shadow: mkShadow(12, 3),
          stroke: 'rgba(0,0,0,0.6)',
          strokeWidth: Math.max(1, Math.round(1 * scale)),
          customName: 'Spruch',
          lineHeight: 1.4,
          fill: 'rgba(255,255,255,0.9)',
        });
      }

      // ── WIDMUNG: Ganz unten, dezent, elegant ──
      if (answers.dedication && answers.dedication.trim()) {
        addTextbox(answers.dedication.trim(), {
          top: Math.round(vH * 0.87),
          fontSize: Math.round(17 * scale),
          fontFamily: 'Raleway',
          fontWeight: '400',
          fontStyle: 'italic',
          shadow: mkShadow(8, 2),
          stroke: 'rgba(0,0,0,0.4)',
          strokeWidth: Math.max(1, Math.round(0.8 * scale)),
          customName: 'Widmung',
          fill: 'rgba(255,255,255,0.75)',
          charSpacing: 50,
        });
      }

      canvas.discardActiveObject();
      canvas.renderAll();

      speech.unmute();
      // Nicht vorlesen

      setGenerating(false);
      setStep('preview');
    }, 400);
  }, [canvasManager, selectedCategory, answers, selectedBg, currentSpruch]);

  const handleBack = useCallback(() => {
    // Gallery mode back navigation
    if (mode === 'gallery') {
      if (galleryStep === 'customize') {
        setGalleryStep('browse');
        setSelectedTemplate(null);
      } else {
        onClose();
      }
      return;
    }
    // Wizard mode back navigation
    if (step === 'preview') setStep('background');
    else if (step === 'background') setStep('questions');
    else if (step === 'questions') { setStep('categories'); setSelectedCategory(null); }
    else onClose();
  }, [mode, galleryStep, step, onClose]);

  // Spruch auf der Leinwand austauschen (im Preview)
  const handleSwapSpruch = useCallback(() => {
    if (!canvasManager || !selectedCategory || !window.fabric) return;
    const newSpruch = getRandomSpruch(selectedCategory.id, selectedMood);
    setCurrentSpruch(newSpruch);

    const canvas = canvasManager.canvas;
    const spruchObj = canvas.getObjects().find(o => o.customName === 'Spruch');
    if (spruchObj) canvas.remove(spruchObj);

    if (newSpruch.text) {
      speech.mute();
      const scale = canvasManager.getObjScale();
      const vW = canvasManager.vWidth;
      const vH = canvasManager.vHeight;
      const maxW = Math.round(vW * 0.80);

      const tb = new window.fabric.Textbox(`„${newSpruch.text}"`, {
        width: maxW,
        left: Math.round(vW / 2),
        top: Math.round(vH * 0.68),
        originX: 'center',
        originY: 'top',
        textAlign: 'center',
        fontSize: Math.round(22 * scale),
        fontFamily: newSpruch.font,
        fontStyle: 'italic',
        fill: 'rgba(255,255,255,0.9)',
        shadow: new window.fabric.Shadow({
          color: 'rgba(0,0,0,0.9)', blur: Math.round(12 * scale), offsetX: 0, offsetY: Math.round(3 * scale),
        }),
        stroke: 'rgba(0,0,0,0.6)',
        strokeWidth: Math.max(1, Math.round(1 * scale)),
        paintFirst: 'stroke',
        strokeLineJoin: 'round',
        editable: false,
        customName: 'Spruch',
        lineHeight: 1.4,
      });
      canvas.add(tb);
      speech.unmute();
    }

    canvas.discardActiveObject();
    canvas.renderAll();
  }, [canvasManager, selectedCategory, selectedMood]);

  // Canvas komplett leeren
  const handleClearCanvas = useCallback(() => {
    if (!canvasManager) return;
    // Remove all objects
    canvasManager.canvas.getObjects().slice().forEach(obj => {
      canvasManager.canvas.remove(obj);
    });
    // Reset background
    canvasManager.canvas.setBackgroundImage(null, canvasManager.canvas.renderAll.bind(canvasManager.canvas));
    canvasManager.canvas.setBackgroundColor('#ffffff', canvasManager.canvas.renderAll.bind(canvasManager.canvas));
    canvasManager.canvas.renderAll();
    // Nicht vorlesen
  }, [canvasManager]);

  const handleNewDesign = useCallback(() => {
    setStep('categories');
    setSelectedCategory(null);
    setAnswers({});
    setBgImages([]);
    setSelectedBg(null);
    setCurrentSpruch({ text: '', font: 'Dancing Script', mood: '' });
    setSelectedMood(null);
  }, []);

  // ── Mode-Wechsel ──
  const handleSwitchToGallery = useCallback(() => {
    setMode('gallery');
    setGalleryStep('browse');
    setSelectedTemplate(null);
  }, []);

  const handleSwitchToWizard = useCallback(() => {
    setMode('wizard');
    setStep('categories');
    setSelectedCategory(null);
    setAnswers({});
    setBgImages([]);
    setSelectedBg(null);
    setCurrentSpruch({ text: '', font: 'Dancing Script', mood: '' });
    setSelectedMood(null);
  }, []);

  const canProceed = selectedCategory && selectedCategory.questions.length > 0
    ? Boolean(answers[selectedCategory.questions[0].key]?.trim())
    : false;

  // ── Header-Titel für verschiedene Modi ──
  const getHeaderTitle = () => {
    if (mode === 'gallery') {
      if (galleryStep === 'customize') return selectedTemplate?.name || 'Vorschlag anpassen';
      return 'Vorschläge';
    }
    const stepTitle = {
      categories: 'Vorschläge & Anlässe',
      questions: selectedCategory?.label,
      background: 'Hintergrund & Spruch',
      preview: 'Entwurf erstellt!',
    };
    return stepTitle[step];
  };

  const getHeaderSubtitle = () => {
    if (mode === 'gallery') {
      if (galleryStep === 'customize') return 'Felder ausfüllen und laden';
      return 'Professionelle Design-Vorschläge';
    }
    const stepSubtitle = {
      categories: 'Wähle einen Anlass',
      questions: 'Beantworte kurz die Fragen',
      background: 'Hintergrund und Spruch wählen',
      preview: 'Du kannst alles weiter bearbeiten',
    };
    return stepSubtitle[step];
  };

  const showBackButton = mode === 'gallery' ? galleryStep === 'customize' : step !== 'categories';

  const spruchCount = selectedCategory ? getSpruchCount(selectedCategory.id) : 0;

  return (
    <div
      className="fixed z-[100] bg-white dark:bg-[#2c2c2e] rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 overflow-hidden animate-slideInLeft flex flex-col"
      style={{ left: 84, top: 60, width: 400, maxHeight: 'calc(100vh - 120px)' }}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-violet-500 to-purple-600 text-white shrink-0">
        <div className="flex items-center gap-2">
          {showBackButton && (
            <button onClick={handleBack} className="w-7 h-7 rounded-full hover:bg-white/20 flex items-center justify-center transition-colors">
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6"/></svg>
            </button>
          )}
          <div>
            <p className="text-sm font-semibold leading-tight">{getHeaderTitle()}</p>
            <p className="text-[10px] text-white/70">{getHeaderSubtitle()}</p>
          </div>
        </div>
        <button onClick={onClose} className="w-7 h-7 rounded-full hover:bg-white/20 flex items-center justify-center transition-colors">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
      </div>

      {/* Tab-Bar: Vorschläge | Eigener Entwurf */}
      {(mode === 'gallery' && galleryStep === 'browse') || (mode === 'wizard' && step === 'categories') ? (
        <div className="flex shrink-0 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-[#1c1c1e]">
          <button
            onClick={handleSwitchToGallery}
            className={`flex-1 py-2.5 text-xs font-semibold text-center transition-all relative ${
              mode === 'gallery'
                ? 'text-violet-600 dark:text-violet-400'
                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            <span className="flex items-center justify-center gap-1.5">
              <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
              Vorschläge
            </span>
            {mode === 'gallery' && (
              <div className="absolute bottom-0 left-2 right-2 h-0.5 bg-violet-500 rounded-full" />
            )}
          </button>
          <button
            onClick={handleSwitchToWizard}
            className={`flex-1 py-2.5 text-xs font-semibold text-center transition-all relative ${
              mode === 'wizard'
                ? 'text-violet-600 dark:text-violet-400'
                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            <span className="flex items-center justify-center gap-1.5">
              <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10"/></svg>
              Eigener Entwurf
            </span>
            {mode === 'wizard' && (
              <div className="absolute bottom-0 left-2 right-2 h-0.5 bg-violet-500 rounded-full" />
            )}
          </button>
        </div>
      ) : mode === 'wizard' ? (
        /* Progress dots — nur im Wizard-Modus nach Kategorien-Schritt */
        <div className="flex items-center justify-center gap-2 py-2 shrink-0 bg-gray-50 dark:bg-[#1c1c1e]">
          {['categories', 'questions', 'background', 'preview'].map((s, i) => (
            <div key={s} className={`w-2 h-2 rounded-full transition-all ${step === s ? 'bg-violet-500 scale-125' : i < ['categories', 'questions', 'background', 'preview'].indexOf(step) ? 'bg-violet-300' : 'bg-gray-300 dark:bg-gray-600'}`} />
          ))}
        </div>
      ) : null}

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-3">

        {/* ════════════════════════════════════════════════════════ */}
        {/*  TEMPLATE GALLERY MODE                                  */}
        {/* ════════════════════════════════════════════════════════ */}

        {mode === 'gallery' && galleryStep === 'browse' && (
          <div className="space-y-3">
            {/* Kategorie-Filter Pills */}
            <div className="flex flex-wrap gap-1.5">
              {galleryCategories.map(cat => (
                <button
                  key={cat}
                  onClick={() => setGalleryCategory(cat)}
                  className={`px-3 py-1.5 rounded-full text-[11px] font-semibold transition-all ${
                    galleryCategory === cat
                      ? 'bg-violet-500 text-white shadow-sm'
                      : 'bg-gray-100 dark:bg-[#3a3a3c] text-gray-600 dark:text-gray-400 hover:bg-violet-100 dark:hover:bg-violet-900/20 hover:text-violet-600 dark:hover:text-violet-400'
                  }`}
                >
                  {TEMPLATE_CATEGORY_LABELS[cat] || cat}
                </button>
              ))}
            </div>

            {/* Lade-Zustand: Skeleton-Cards */}
            {galleryLoading && (
              <div className="grid grid-cols-2 gap-2.5">
                {[1,2,3,4].map(i => <SkeletonCard key={i} />)}
              </div>
            )}

            {/* Fehler-Zustand */}
            {galleryError && !galleryLoading && (
              <div className="p-4 bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-200 dark:border-red-700 text-center">
                <svg className="w-8 h-8 mx-auto mb-2 text-red-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/>
                </svg>
                <p className="text-sm text-red-700 dark:text-red-300 font-medium">{galleryError}</p>
                <button
                  onClick={() => { setGalleryLoading(true); setGalleryError(null); setMode('gallery'); }}
                  className="mt-2 text-xs text-violet-600 dark:text-violet-400 underline hover:no-underline"
                >
                  Erneut versuchen
                </button>
              </div>
            )}

            {/* Leerer Zustand */}
            {!galleryLoading && !galleryError && filteredTemplates.length === 0 && (
              <div className="p-6 text-center">
                <svg className="w-10 h-10 mx-auto mb-3 text-gray-300 dark:text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 3v18"/>
                </svg>
                <p className="text-sm text-gray-500 dark:text-gray-400 font-medium">Keine Vorschläge in dieser Kategorie</p>
                <p className="text-[11px] text-gray-400 dark:text-gray-500 mt-1">Versuche eine andere Kategorie oder erstelle einen eigenen Entwurf.</p>
              </div>
            )}

            {/* Template-Grid */}
            {!galleryLoading && !galleryError && filteredTemplates.length > 0 && (
              <div className="grid grid-cols-2 gap-2.5">
                {filteredTemplates.map(template => (
                  <button
                    key={template.id}
                    onClick={() => handleSelectTemplate(template)}
                    className="group rounded-xl overflow-hidden border-2 border-gray-200 dark:border-gray-700 hover:border-violet-400 dark:hover:border-violet-500 bg-white dark:bg-[#3a3a3c] transition-all hover:scale-[1.02] hover:shadow-lg text-left"
                  >
                    {/* Thumbnail */}
                    <div className="aspect-video bg-gray-100 dark:bg-gray-700 overflow-hidden relative">
                      <img
                        src={template.thumbnail}
                        alt={template.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        loading="lazy"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.parentNode.classList.add('flex', 'items-center', 'justify-center');
                          const placeholder = document.createElement('div');
                          placeholder.className = 'text-3xl';
                          placeholder.textContent = TEMPLATE_CATEGORY_LABELS[template.category] ? (OCCASION_CATEGORIES.find(c => c.id === template.category)?.icon || '📄') : '📄';
                          e.target.parentNode.appendChild(placeholder);
                        }}
                      />
                      {/* Kategorie-Tag */}
                      <div className="absolute top-1.5 right-1.5 px-1.5 py-0.5 rounded-md bg-black/50 backdrop-blur-sm text-[9px] text-white font-medium">
                        {TEMPLATE_CATEGORY_LABELS[template.category] || template.category}
                      </div>
                    </div>
                    {/* Info */}
                    <div className="p-2.5">
                      <p className="text-xs font-semibold text-gray-800 dark:text-gray-200 leading-tight line-clamp-2">{template.name}</p>
                      {template.description && (
                        <p className="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5 leading-snug line-clamp-2">{template.description}</p>
                      )}
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ── Template Customize View ── */}
        {mode === 'gallery' && galleryStep === 'customize' && selectedTemplate && (
          <div className="space-y-3">
            {/* Vorschaubild */}
            <div className="rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-700">
              <img
                src={selectedTemplate.thumbnail}
                alt={selectedTemplate.name}
                className="w-full object-cover"
                style={{ maxHeight: 200 }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>

            {/* Template-Info */}
            <div className="p-3 bg-gray-50 dark:bg-[#3a3a3c] rounded-xl">
              <p className="text-sm font-semibold text-gray-800 dark:text-gray-200">{selectedTemplate.name}</p>
              {selectedTemplate.description && (
                <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5">{selectedTemplate.description}</p>
              )}
              {selectedTemplate.tags && selectedTemplate.tags.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-2">
                  {selectedTemplate.tags.map(tag => (
                    <span key={tag} className="px-2 py-0.5 rounded-full bg-violet-100 dark:bg-violet-900/30 text-[9px] text-violet-600 dark:text-violet-400 font-medium">
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* Editierbare Felder */}
            {selectedTemplate.editableFields && selectedTemplate.editableFields.length > 0 && (
              <div className="space-y-2.5">
                <p className="text-xs font-semibold text-gray-600 dark:text-gray-400 flex items-center gap-1.5">
                  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  Deine Angaben
                </p>
                {selectedTemplate.editableFields.map((field, i) => (
                  <div key={field.key}>
                    <label className="block text-[11px] font-semibold text-gray-600 dark:text-gray-400 mb-1">{field.label}</label>
                    <input
                      ref={i === 0 ? firstInputRef : null}
                      type="text"
                      value={templateFieldValues[field.key] || ''}
                      onChange={e => handleTemplateFieldChange(field.key, e.target.value)}
                      placeholder={field.placeholder}
                      className="w-full px-3 py-2.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-[#1c1c1e] text-sm text-gray-800 dark:text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-violet-400 transition-all"
                      onKeyDown={e => { if (e.key === 'Enter' && canLoadTemplate) handleLoadTemplate(); }}
                    />
                  </div>
                ))}
              </div>
            )}

            {/* Vorlage laden Button */}
            <button
              onClick={handleLoadTemplate}
              disabled={!canLoadTemplate || templateLoading}
              className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              style={{ background: canLoadTemplate ? 'linear-gradient(135deg, #8b5cf6, #6d28d9)' : '#9ca3af' }}
            >
              {templateLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round"/></svg>
                  Vorlage wird geladen...
                </span>
              ) : (
                <span className="flex items-center justify-center gap-2">
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/></svg>
                  Vorlage laden
                </span>
              )}
            </button>

            {/* Andere Vorlage wählen (behält eingegebene Daten) */}
            <button
              onClick={() => { setGalleryStep('browse'); setSelectedTemplate(null); }}
              className="w-full py-2.5 rounded-xl text-sm font-semibold border-2 border-violet-300 dark:border-violet-500 text-violet-600 dark:text-violet-400 hover:bg-violet-50 dark:hover:bg-violet-900/20 transition-all flex items-center justify-center gap-2"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 5l7 7-7 7"/></svg>
              Andere Vorlage wählen
            </button>

            {/* Design zurücksetzen */}
            <button
              onClick={handleClearCanvas}
              className="w-full py-2 rounded-xl text-[11px] font-medium text-red-500 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all flex items-center justify-center gap-1.5"
            >
              <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>
              Design zurücksetzen
            </button>

            {/* Hinweis */}
            <p className="text-[10px] text-gray-400 dark:text-gray-500 text-center leading-snug">
              Nach dem Laden kannst du alle Elemente frei bearbeiten, verschieben und anpassen.
            </p>
          </div>
        )}

        {/* ════════════════════════════════════════════════════════ */}
        {/*  WIZARD MODE (bestehender Flow)                         */}
        {/* ════════════════════════════════════════════════════════ */}

        {/* ── Categories ── */}
        {mode === 'wizard' && step === 'categories' && (
          <div className="grid grid-cols-3 gap-2">
            {OCCASION_CATEGORIES.map(cat => (
              <button
                key={cat.id}
                onClick={() => handleSelectCategory(cat)}
                className="flex flex-col items-center gap-1.5 p-3 rounded-xl border-2 border-transparent hover:border-violet-300 dark:hover:border-violet-500 bg-gray-50 dark:bg-[#3a3a3c] hover:bg-violet-50 dark:hover:bg-violet-900/20 transition-all group"
              >
                <span className="text-2xl group-hover:scale-110 transition-transform">{cat.icon}</span>
                <span className="text-[10px] font-semibold text-gray-700 dark:text-gray-300 leading-tight text-center">{cat.label}</span>
              </button>
            ))}
          </div>
        )}

        {/* ── Questions ── */}
        {mode === 'wizard' && step === 'questions' && selectedCategory && (
          <div className="space-y-3">
            <div className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-[#3a3a3c] rounded-xl">
              <span className="text-3xl">{selectedCategory.icon}</span>
              <div>
                <p className="text-sm font-semibold text-gray-800 dark:text-gray-200">{selectedCategory.label}</p>
                <p className="text-[11px] text-gray-500">Beantworte die Fragen — Lenny macht den Rest!</p>
              </div>
            </div>

            {selectedCategory.questions.map((q, i) => (
              <div key={q.key}>
                <label className="block text-xs font-semibold text-gray-600 dark:text-gray-400 mb-1">{q.label}</label>
                <input
                  ref={i === 0 ? firstInputRef : null}
                  type={q.type || 'text'}
                  value={answers[q.key] || ''}
                  onChange={e => handleAnswerChange(q.key, e.target.value)}
                  placeholder={q.placeholder}
                  className="w-full px-3 py-2.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-[#1c1c1e] text-sm text-gray-800 dark:text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-violet-400 transition-all"
                  onKeyDown={e => { if (e.key === 'Enter' && canProceed) handleNextToBackground(); }}
                />
              </div>
            ))}

            <button
              onClick={handleNextToBackground}
              disabled={!canProceed}
              className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              style={{ background: canProceed ? 'linear-gradient(135deg, #8b5cf6, #6d28d9)' : '#9ca3af' }}
            >
              Weiter — Hintergrund & Spruch
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
            </button>
          </div>
        )}

        {/* ── Background & Spruch Selection ── */}
        {mode === 'wizard' && step === 'background' && (
          <div className="space-y-3">
            {/* ── Stimmungs-Auswahl ── */}
            {selectedCategory && getMoodsForCategory(selectedCategory.id).length > 1 && (
              <div className="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-xl border border-amber-200 dark:border-amber-700">
                <p className="text-xs font-semibold text-amber-700 dark:text-amber-300 mb-2">Welche Stimmung soll der Spruch haben?</p>
                <div className="flex flex-wrap gap-1.5">
                  {getMoodsForCategory(selectedCategory.id).map(mood => (
                    <button
                      key={mood}
                      onClick={() => setSelectedMood(mood)}
                      className={`px-3 py-1.5 rounded-lg text-[11px] font-semibold transition-all ${
                        selectedMood === mood
                          ? 'bg-amber-500 text-white shadow-sm'
                          : 'bg-white dark:bg-[#1c1c1e] text-gray-700 dark:text-gray-300 border border-amber-200 dark:border-amber-700 hover:border-amber-400'
                      }`}
                    >
                      {MOOD_LABELS[mood] || mood}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* ── Spruch Section ── */}
            <div className="p-3 bg-violet-50 dark:bg-violet-900/20 rounded-xl border border-violet-200 dark:border-violet-700">
              <div className="flex items-center justify-between mb-2">
                <p className="text-xs font-semibold text-violet-700 dark:text-violet-300 flex items-center gap-1.5">
                  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
                  Spruch ({spruchCount} verfügbar)
                </p>
                <button
                  onClick={handleRefreshSpruch}
                  className="flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-semibold text-violet-600 dark:text-violet-400 hover:bg-violet-100 dark:hover:bg-violet-800/30 transition-all"
                  title="Neuer Spruch"
                >
                  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 4v6h-6M1 20v-6h6"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/></svg>
                  Neuer Spruch
                </button>
              </div>
              {currentSpruch.text ? (
                <div className="bg-white dark:bg-[#1c1c1e] rounded-lg p-3 border border-violet-100 dark:border-violet-800">
                  <p className="text-sm text-gray-800 dark:text-gray-200 italic leading-relaxed">
                    „{currentSpruch.text}"
                  </p>
                  <p className="text-[9px] text-violet-400 mt-1.5">
                    Schrift: {currentSpruch.font} · {MOOD_LABELS[currentSpruch.mood] || currentSpruch.mood}
                  </p>
                </div>
              ) : (
                <p className="text-[11px] text-gray-500 italic">Kein Spruch für diese Kategorie.</p>
              )}
            </div>

            {/* Solid color option */}
            <button
              onClick={() => setSelectedBg({ type: 'color' })}
              className={`w-full flex items-center gap-3 p-3 rounded-xl border-2 transition-all ${selectedBg?.type === 'color' ? 'border-violet-500 bg-violet-50 dark:bg-violet-900/20' : 'border-gray-200 dark:border-gray-600 hover:border-violet-300'}`}
            >
              <div className="w-12 h-12 rounded-lg shrink-0" style={{ background: selectedCategory?.fallbackBg || '#1e3a5f' }} />
              <div className="text-left">
                <p className="text-xs font-semibold text-gray-800 dark:text-gray-200">Nur Hintergrundfarbe</p>
                <p className="text-[10px] text-gray-500">Einfarbig, ohne Foto</p>
              </div>
            </button>

            {/* Pixabay images */}
            <div>
              <p className="text-xs font-semibold text-gray-600 dark:text-gray-400 mb-2 flex items-center gap-1.5">
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                Hintergrundbilder von Pixabay
              </p>
              {bgLoading ? (
                <div className="flex items-center justify-center py-8">
                  <svg className="w-6 h-6 animate-spin text-violet-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round"/></svg>
                  <span className="ml-2 text-xs text-gray-500">Bilder werden geladen...</span>
                </div>
              ) : (
                <div className="grid grid-cols-3 gap-1.5">
                  {bgImages.map(hit => (
                    <button
                      key={hit.id}
                      onClick={() => setSelectedBg({ type: 'image', url: hit.largeImageURL, preview: hit.webformatURL })}
                      className={`relative rounded-lg overflow-hidden border-2 transition-all aspect-video ${selectedBg?.url === hit.largeImageURL ? 'border-violet-500 ring-2 ring-violet-300 scale-[1.02]' : 'border-transparent hover:border-violet-300'}`}
                    >
                      <img src={hit.webformatURL} alt={hit.tags} className="w-full h-full object-cover" loading="lazy" />
                      {selectedBg?.url === hit.largeImageURL && (
                        <div className="absolute inset-0 bg-violet-500/20 flex items-center justify-center">
                          <svg className="w-6 h-6 text-white drop-shadow-lg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M20 6L9 17l-5-5"/></svg>
                        </div>
                      )}
                    </button>
                  ))}
                </div>
              )}
              {bgImages.length > 0 && (
                <p className="text-[9px] text-gray-400 mt-1.5 text-center">Bilder: Pixabay.com — kostenlos & lizenzfrei</p>
              )}
            </div>

            {/* Generate button */}
            <button
              onClick={handleGenerate}
              disabled={!selectedBg || generating}
              className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all disabled:opacity-40 disabled:cursor-not-allowed"
              style={{ background: selectedBg ? 'linear-gradient(135deg, #8b5cf6, #6d28d9)' : '#9ca3af' }}
            >
              {generating ? (
                <span className="flex items-center justify-center gap-2">
                  <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round"/></svg>
                  Lenny gestaltet...
                </span>
              ) : (
                <span className="flex items-center justify-center gap-2">
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10"/></svg>
                  Entwurf erstellen
                </span>
              )}
            </button>
          </div>
        )}

        {/* ── Preview / Done ── */}
        {mode === 'wizard' && step === 'preview' && (
          <div className="space-y-4">
            <div className="p-4 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-200 dark:border-green-700 text-center">
              <span className="text-4xl block mb-2">✨</span>
              <p className="text-sm font-semibold text-green-800 dark:text-green-300">Dein Entwurf ist auf der Leinwand!</p>
              <p className="text-[11px] text-green-600 dark:text-green-400 mt-1">
                Klicke auf Texte um sie zu bearbeiten, verschiebe Elemente oder ändere Farben.
              </p>
            </div>

            {/* Spruch wechseln */}
            {spruchCount > 0 && (
              <div className="p-3 bg-violet-50 dark:bg-violet-900/20 rounded-xl border border-violet-200 dark:border-violet-700">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-xs font-semibold text-violet-700 dark:text-violet-300 flex items-center gap-1.5">
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
                    Spruch auf der Leinwand
                  </p>
                  <button
                    onClick={handleSwapSpruch}
                    className="flex items-center gap-1 px-2.5 py-1 rounded-lg text-[10px] font-semibold bg-violet-500 text-white hover:bg-violet-600 transition-all"
                    title="Anderen Spruch auf die Leinwand setzen"
                  >
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 4v6h-6M1 20v-6h6"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/></svg>
                    Anderer Spruch
                  </button>
                </div>
                <p className="text-[11px] text-gray-600 dark:text-gray-400 italic leading-relaxed">
                  „{currentSpruch.text}"
                </p>
                <p className="text-[9px] text-violet-400 mt-1">
                  {currentSpruch.font} · {spruchCount} Sprüche verfügbar
                </p>
              </div>
            )}

            <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 dark:border-blue-700">
              <p className="text-[11px] font-semibold text-blue-800 dark:text-blue-300 mb-1">Tipps:</p>
              <ul className="text-[10px] text-blue-600 dark:text-blue-400 space-y-0.5">
                <li>• Doppelklick auf Text zum Bearbeiten</li>
                <li>• Cliparts & Formen links in der Toolbar</li>
                <li>• Eigene Fotos über "Bilder" hinzufügen</li>
              </ul>
            </div>

            <div className="space-y-2">
              <button
                onClick={handleClearCanvas}
                className="w-full py-2.5 rounded-xl text-sm font-semibold border-2 border-red-300 dark:border-red-500 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all flex items-center justify-center gap-2"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>
                Entwurf leeren
              </button>
              <button
                onClick={handleNewDesign}
                className="w-full py-2.5 rounded-xl text-sm font-semibold border-2 border-violet-300 dark:border-violet-500 text-violet-600 dark:text-violet-400 hover:bg-violet-50 dark:hover:bg-violet-900/20 transition-all"
              >
                Anderen Anlass wählen
              </button>
              <button
                onClick={onClose}
                className="w-full py-2.5 rounded-xl text-sm font-semibold text-white transition-all"
                style={{ background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)' }}
              >
                Weiter bearbeiten
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TemplateWizard;
